import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TdDialogService, ITdDataTableColumn } from '@covalent/core';
import { Route } from '@angular/router/src/config';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { ReceivingService } from '../../../receiving/receiving.service';
import { ReceivingItem } from '../../../receiving/receiving-item';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';
import { InventoryService } from '../../../inventory/inventory.service';
import { Piece } from '../../../inventory/piece';
import { LocationService } from 'services/location.service';

@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.scss']
})
export class TransferComponent implements OnInit {
  receivingNumber: string;
  order_items: ReceivingItem[] = [];

  order_number: string = '';
  _branch_id: number;
  id: string;

  translatePipe: TranslatePipe = new TranslatePipe();
  piece_location: string = '';

  external_order: boolean = true;
  locations: any[] = [];

  transaction_status: string[] = [];
  confirmation_length: number = 0;

  columns: ITdDataTableColumn[] = [
    { name: 'piece_no', label: this.translatePipe.transform('piece_no', this._authService.getLanguage()) },
    { name: 'collection', label: this.translatePipe.transform('collection', this._authService.getLanguage()) },
    { name: 'design', label: this.translatePipe.transform('design', this._authService.getLanguage()) },
    { name: 'color', label: this.translatePipe.transform('color', this._authService.getLanguage()) },
    { name: 'length', label: this.translatePipe.transform('length', this._authService.getLanguage()) },
    { name: 'weight', label: this.translatePipe.transform('weight_kg', this._authService.getLanguage()) },
  ];

  constructor(private router: Router,
    private _locationService: LocationService,
    private _dialogService: TdDialogService,
    private _inventoryService: InventoryService,
    private _receivingService: ReceivingService,
    private location: Location,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
  }

  goBack(): void {
    this.location.back();
  }

  getLocations(branch_id) {
    this._locationService.getLocations(branch_id).subscribe(
      response => {
        this.locations = response;
      }
    );
  }

  search() {
    this._receivingService.getReceivingItemsByReceivingNumber(this.receivingNumber).subscribe(
      response => {
        if (response && Array.isArray(response) && response.length > 0) {
          this.order_items = response;

          this._receivingService.getReceiving(response[0]['receiving_orders_id']).subscribe(
            rec_order => {
              this.order_number = rec_order['receiving_number'];
              this.id = rec_order.id + '';
              this._branch_id = rec_order['requesting_branch_id'];
              this.external_order = (Number.parseInt(rec_order['supplier_id']) != 0);

              this.getLocations(this._branch_id);

              if (rec_order.status != 'PACKING LIST') {
                this._dialogService.openAlert({
                  title: 'Problem',
                  message: 'The selected Receiving order is not in PACKING LIST status. Cannot mark as received'
                })

                this.order_items = [];
              }

            }
          );
        }
      }
    );
  }

  confirmOrder() {
    if (this.locations.find((l) => { return l.name == this.piece_location }) == null) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The location that you scanned is not registered in this receiving\'s branch'
      });
      return;
    }

    this._dialogService.openConfirm({
      title: 'Warning!',
      message: 'You are going to scan all items at once. Are you sure?',
      acceptButton: 'Yes',
      cancelButton: 'No'
    }).afterClosed().subscribe(
      result => {
        if (result) {
          this.doConfirmOrder(this.order_items);
        }
      }
    );
  }

  doConfirmOrder(final_items: ReceivingItem[]) {
    // We expect final_items.length + 1 confirmations
    this.confirmation_length = final_items.length + 1;

    // Set the receiving order to RECEIVED
    this._receivingService.getReceiving(this.id).subscribe(
      response => {
        if (response != null) {
          response.status = 'RECEIVED';
          this._receivingService.updateReceiving(response).subscribe(
            response => {
              this.reportStatus('Receiving marked as RECEIVED', true);
            },
            error => {
              this.reportStatus('Could not mark Receiving as RECEIVED', true);
            }
          );
        }
      }
    );

    // Set the scanned length and weight of the receiving pieces
    this._receivingService.createReceivingItems(this.id, this.order_items).subscribe(
      response => {

      }
    );

    // Add the pieces to the inventory
    final_items.forEach(
      (item) => {
        let piece: Piece = new Piece();

        piece.piece_number = item.piece_no;
        // This to figure out the color_id 
        piece.color_name = item.color;
        piece.collection_name = item.collection;
        piece.design_name = item.design;
        // Piece specs
        piece.lot_number = item.lot_no;
        piece.length = item.length;
        piece.weight = item.weight;
        // Location
        // id is most likely null, need branch
        piece.location_id = Number.parseInt(item.location_id);
        piece.location_name = this.piece_location;

        piece.branch_id = this._branch_id;

        // Add it to the inventory!
        this._inventoryService.addPiece(piece, this.external_order).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.reportStatus('Piece ' + response['piece_number'] + ' added to the inventory');
              console.log('Piece ' + response['piece_number'] + ' added to the inventory');
            } else {
              this.reportStatus('Piece ' + response['piece_number'] + ' could not be added to the inventory');
              console.log('Piece ' + response['piece_number'] + ' could not be added to the inventory');
            }
          },
          error => {
            this.reportStatus('Piece ' + error['piece_number'] + ' could not be added to the inventory');
            console.log('Piece ' + error['piece_number'] + ' could not be added to the inventory');
          }
        );
      }
    )
  }

  reportStatus(status: string, prepend?: boolean) {
    if (prepend) {
      this.transaction_status.unshift(status);
    } else {
      this.transaction_status.push(status);
    }

    if (this.transaction_status.length == this.confirmation_length) {
      let len = this.transaction_status.length;

      this._dialogService.openAlert(
        {
          title: 'Result',
          // if longer than 10 only show the first 10
          message: this.transaction_status.slice(0, 10).join(', ') + 
          (len > 10 ? '... and ' + (len - 10) + ' more' : '')
        }
      ).afterClosed().subscribe(
        result => {
          this.router.navigate(['/pda', 'receiving']);
        });
    }
  }


}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/receiving/transfer/transfer.component.ts